import { Sidebar } from 'primereact/sidebar';
import { formatUTCDate } from '../../../../../utils/formatUtils';
import ContractDrilldownData from './ContractDrilldownData';

type ContractHistoryDrilldownContainerProps = {
  contract: any | null;
  onHide: () => void;
};

const ContractHistoryDrilldownContainer = ({
  contract,
  onHide,
}: ContractHistoryDrilldownContainerProps) => {
  return (
    <Sidebar
      visible={!!contract}
      position="right"
      onHide={onHide}
      className="w-full max-w-600px"
    >
      <div className="blackText text-standard drilldownContent">
        <div className="text-28px font-bold text-center mt-4 mb-1">
          Job Setup Info Details
        </div>
        <div className="grid mx-3 mt-3 mb-2">
          <div className="col-12 sm:col-6">
            <label className="text-18px block mb-1 font-bold">
              Submitted By:
            </label>
            {contract.user.firstName} {contract.user.lastName}
          </div>
          <div className="col-12 sm:col-6">
            <label className="text-18px block mb-1 font-bold">Date:</label>
            {formatUTCDate(contract.createdAt)}
          </div>
        </div>
        <div>
          <ContractDrilldownData id={contract.id} />
        </div>
      </div>
    </Sidebar>
  );
};

export default ContractHistoryDrilldownContainer;
